import analytics from "roaarrr-browser";

// Track activation event when user creates their first Stix (post)
export const trackActivation = (userId, postId, postType = "post") => {
  try {
    analytics.track("activation", {
      userId,
      postId,
      postType,
      timestamp: new Date().toISOString(),
      platform: "web",
      source: "stix-app",
    });
    console.log("Activation event tracked successfully");
  } catch (error) {
    console.error("Failed to track activation event:", error);
  }
};

// Track other custom events
export const trackEvent = (eventName, properties = {}) => {
  try {
    analytics.track(eventName, {
      ...properties,
      timestamp: new Date().toISOString(),
      platform: "web",
      source: "stix-app",
    });
    console.log(`Event '${eventName}' tracked successfully`);
  } catch (error) {
    console.error(`Failed to track event '${eventName}':`, error);
  }
};

// Track page views
export const trackPageView = (pageName, properties = {}) => {
  try {
    analytics.page(pageName, {
      ...properties,
      timestamp: new Date().toISOString(),
      platform: "web",
      source: "stix-app",
    });
    console.log(`Page view '${pageName}' tracked successfully`);
  } catch (error) {
    console.error(`Failed to track page view '${pageName}':`, error);
  }
};

// Track user identification
export const identifyUser = (userId, userProperties = {}) => {
  try {
    analytics.identify(userId, {
      ...userProperties,
      timestamp: new Date().toISOString(),
      platform: "web",
      source: "stix-app",
    });
    console.log(`User '${userId}' identified successfully`);
  } catch (error) {
    console.error(`Failed to identify user '${userId}':`, error);
  }
};
